module.exports = __webpack_public_path__ + "img/1.672db77b.png";